import { render, staticRenderFns } from "./ProductsFeatureCard.vue?vue&type=template&id=359ed0e1&scoped=true"
import script from "./ProductsFeatureCard.vue?vue&type=script&lang=js"
export * from "./ProductsFeatureCard.vue?vue&type=script&lang=js"
import style0 from "./ProductsFeatureCard.vue?vue&type=style&index=0&id=359ed0e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359ed0e1",
  null
  
)

export default component.exports